// Your Redux reducer
import { UPDATE_BOOKING_DETAILS } from '../actions/customerBookingDetails'; // Import action type

const initialState = {
  booking: {
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    outboundFlightNumber: '',
    returnFlightNumber: '',
    accommodationName: '',
    accommodationAddress: '',
    pickupAccommodationName:'',
    pickupAccommodationAddress:'',
    holdLuggageQty: 0,
    skisSnowboardsQty: 0,
    bikesGolfBagsQty: 0,
    // Add other fields as needed
  },
  // Other properties of your state if any
};

const cutomerBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_BOOKING_DETAILS:
      return {
        ...state,
        booking: {
          ...state.booking,
          ...action.payload,
        },
      };
    // Other cases...
    default:
      return state;
  }
};

export default cutomerBookingReducer;
